import { PropsWithChildren } from "react";
import { AuthProvider } from "../../features/auth/shared/hooks/useAuth";

export default function AppProviders({ children }: PropsWithChildren) {
  return <AuthProvider>{children}</AuthProvider>;
}
